/**
 * O que cada licença abre no app do distribuidor.
 *
 * Isto é conveniência de interface, não controle de acesso: quem barra de
 * verdade é o backend (`LicencaDistribuidorGuard`), porque esconder um item de
 * menu não impede ninguém de chamar a API na mão. O objetivo aqui é não
 * oferecer tela que vai responder 403.
 */

export const COMPLETA = "COMPLETA";
export const GESTAO_FORNECIMENTO = "GESTAO_FORNECIMENTO";
export const DISTRIBUICAO = "DISTRIBUICAO";

/**
 * Prefixos de rota liberados na licença de gestão de fornecimento.
 *
 * É lista de permissão, e não de bloqueio, pelo mesmo motivo do backend: rota
 * nova nasce fora da licença menor até alguém decidir o contrário.
 */
const ROTAS_DA_GESTAO_DE_FORNECIMENTO = [
	"/home",
	"/unidades",
	"/distribuidora",
	"/fornecedores",
	"/solicitacoes",
	"/usuarios",
	"/coletas",
	"/whatsapp",
	"/relatorios",
	// Conta do próprio usuário logado (nome, e-mail, login e senha). Não é
	// funcionalidade contratada: todo usuário autenticado precisa dela.
	"/configuracoes",
];

/**
 * Prefixos de rota que a licença de distribuição não cobre.
 *
 * Aqui a lista é de bloqueio, ao contrário da de cima: distribuição é a licença
 * completa menos a operação de coleta, então enumerar o que ela permite seria
 * listar o sistema inteiro e deixar toda tela nova de fora por esquecimento.
 * Espelha o `@ForaDaDistribuicao()` do backend.
 */
const ROTAS_FORA_DA_DISTRIBUICAO = ["/coletas"];

/**
 * Abas de Relatórios liberadas na licença menor, pelo índice em que aparecem na
 * tela. Entradas, saídas, balanço e rastreabilidade detalham compra, venda e
 * produção — e o backend recusa esses endpoints para esta licença.
 */
export const ABAS_DE_RELATORIO_DA_GESTAO_DE_FORNECIMENTO = ["Visão Geral", "Fornecimento"];

/**
 * Abas de Relatórios escondidas na licença de distribuição. O relatório de
 * fornecimento é montado inteiro em cima das coletas: sem elas ele só teria
 * zeros para mostrar.
 */
export const ABAS_DE_RELATORIO_FORA_DA_DISTRIBUICAO = ["Fornecimento"];

/** Abas do cadastro de unidade liberadas na licença menor. */
export const ABAS_DE_DISTRIBUIDORA_DA_GESTAO_DE_FORNECIMENTO = ["Empresa", "Produtos"];

/** Lê o tipo do perfil. Perfil ainda não carregado conta como completa. */
export function tipoDaLicenca(user) {
	return user?.tipoLicenca ?? user?.empresaDistribuidor?.licenca?.tipo ?? COMPLETA;
}

export function ehGestaoDeFornecimento(user) {
	return tipoDaLicenca(user) === GESTAO_FORNECIMENTO;
}

export function ehDistribuicao(user) {
	return tipoDaLicenca(user) === DISTRIBUICAO;
}

const casaComAlgum = (caminho, rotas) =>
	rotas.some((rota) => caminho === rota || caminho.startsWith(`${rota}/`));

/** A rota está incluída na licença? */
export function rotaLiberada(caminho, tipo) {
	if (caminho === "/" || caminho === "") return true;

	if (tipo === DISTRIBUICAO) {
		return !casaComAlgum(caminho, ROTAS_FORA_DA_DISTRIBUICAO);
	}

	if (tipo !== GESTAO_FORNECIMENTO) return true;

	return casaComAlgum(caminho, ROTAS_DA_GESTAO_DE_FORNECIMENTO);
}
